export const acts = {
  act1: "act1",
  act2: "act2",
  act3: "act3",
};
